export default () => window.parent !== window.self
